import Navbar from "./components/Navbar";
import About from "./components/About";
import Service from "./components/Service";
// import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import Achievement from "./components/Achievement";
import Member from "./components/Member";
import './index.css';

export default function App() {
    return (
        <>
            <Navbar />
            <Hero />
            <About />
            <Service />
            {/* <Projects /> */}
            <Achievement />
            <Member/>
            <Contact />
            <Footer />
        </>
    );
}